<template>
  <nav class="navbar-container ss2-3-submenu-icon-template">
    <div class="container gx-0">
      <div class="row gx-0  ">
        <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2	col-xxl-2 p-1 d-flex align-items-center ">
          <div class="header-logo">
            <img src="/static/img/logo/logo.png" width="100%" class=" " alt="brand-logo" />
          </div>
        </div>
        <div
          class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10	col-xxl-10 p-1  d-flex d-flex justify-content-center justify-content-sm-center justify-content-md-end justify-content-lg-end justify-content-xl-end justify-content-xxl-end">
          <div class="login-bar">
            <div class="beforeLoginBar ">
              <div class="header-control-inner">
                <div class="forgotPass">
                </div>
                <div class="form-control">

                  <div class="row gx-0  ">
                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6	col-xxl-6  d-flex align-items-center  "
                      style="padding:5px;">
                      <div class="standard-form-field d-block  ">
                        <input type="text" class="standard-input" v-model="phoneNumber" placeholder="ยูสเซอร์เนม"
                          value="" />
                      </div>
                      <div class="standard-form-field d-block ">
                        <div class="standard-form-field-wrapper">
                          <input type="password" v-model="password" class="standard-input" placeholder="รหัสผ่าน"
                            value="" />

                        </div>
                      </div>
                    </div>

                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6	col-xxl-6  d-flex align-items-center "
                      style="padding:5px;">
                      <button @click="Login()" class="btnLogin">เข้าสู่ระบบ</button>
                      <button class="btnJoin" @click="gotoRoute('/register')">
                        <span>ลงทะเบียน</span>
                        <div class="hover_img"></div>
                      </button>
                      <button class="line-login-button d-block d-none  d-lg-block" @click="goToLine()">
                        <img src="/static/img/icon/line.png" alt="" />ติดต่อ
                      </button>
                    </div>

                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="navbar-linear-border null"></div>

    <div class="navMenu-container">
      <div class="container gx-0">
        <div class="row gx-0">
          <div class="col-2 col-lg-1"><a class="headerLink" @click="goToHome()" title="หน้าหลัก" id="menu-home">
              <div class="navbar-item">
                <img src="/static/img/icon/menu-home.png" class="" />
                <p class="m-0 ">หน้าหลัก</p>
              </div>
            </a></div>
        </div>
      </div>
    </div>

  </nav>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";

export default {
  name: "Header",
  data() {
    return {
      isShowNav: true,
      toggle: true,
      nowPage: this.$route.name,
      phoneNumber: "",
      password: "",
    };
  },
  watch: {
    $route() {
      this.isShowNav = true;
      this.nowPage = this.$route.name;
      if (
        this.$route.name == "Login" ||
        this.$route.name == "Signup" ||
        this.$route.name == "Profile" ||
        this.$route.name == "Join"
      ) {
        return (this.isShowNav = false);
      }
    },
  },
  mixins: [UserInfoMixins],
  methods: {
    ...mapActions(["userSignOut", "userSignIn", "appTitle"]),
    gotoRouteGame(route) {
      this.$router.push({ path: route }).catch(() => { });
    },
    async Login() {
      if (
        this.phoneNumber == "" ||
        this.password == "" ||
        this.phoneNumber.length !== 10
      ) {
        return this.$swal.fire(
          "เบอร์โทรศัพท์ หรือ รหัสผ่าน ไม่ถูกต้อง",
          "",
          "error"
        );
      }
      await this.userSignIn({
        phoneNumber: this.phoneNumber,
        password: this.password,
      });
      if (this.getError) {
        return this.$swal.fire(this.getError, "", "error");
      } else {
        // $('#modalLogin').modal('hide')
        if (this.remember == true) {
          localStorage.setItem("remember.username", this.phoneNumber);
          localStorage.setItem("remember.password", this.password);
        } else {
          localStorage.removeItem("remember.username");
          localStorage.removeItem("remember.password");
        }
        localStorage.removeItem("modal-alert");
      }
    },
    gotoRouteMobile(route) {
      var myCollapse = document.getElementById("navbarSupportedContent");
      console.log(myCollapse.classList.contains("show"));
      if (myCollapse.classList.contains("show")) {
        var bsCollapse = new bootstrap.Collapse(myCollapse);
        bsCollapse.hide();
      }
      this.$router.push(route).catch(() => { });
    },
    gotoRoute(route) {
      this.$router.push(route).catch(() => { });
    },
    getPageActive(page) {
      if (this.nowPage == page) {
        return "menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-9";
      }
    },
    async SignOut() {
      await this.userSignOut();
    },
    goToLine() {
      window.open(`https://line.me/R/ti/p/${this.getLineId}`, "_blank");
    },
    goToHome() {
      window.location = '/'

    },
  },
  computed: {
    ...mapGetters(["getLineId"]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/layout/Header.vue